import React, { useEffect, useState } from 'react';
import { PageTitle, PseudoStates } from '@cordata/buffet';
import { useParams } from 'react-router-dom';

import { adminInstance as axiosAdmin } from '~/utils';

import Form from '~/components/ScheduledReport/Form';

const ScheduledReportsDetails = () => {
  const params = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState();

  useEffect(() => {
    axiosAdmin
      .get(`/scheduled-report/${params.scheduled_report_id}`)
      .then(r => r.data.data)
      .then(r => setData(r))
      .catch(e => setError(e))
      .then(() => setIsLoading(false));
  }, []);

  return !isLoading && !error
    ? (<>
      <PageTitle>
        {data.attributes.scheduledReportLabel}
      </PageTitle>

      <Form data={data} />
    </>)
    : (<PseudoStates isLoading={isLoading} error={error} />);
};

export default ScheduledReportsDetails;
